import React from "react";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { FaHome, FaCogs, FaEnvelope, FaArrowRight } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();
    const [contentRef, contentInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <div className="min-h-screen font-sans overflow-hidden relative flex items-center justify-center">
            <div className="container mx-auto px-4 text-center">
                <div className="max-w-2xl mx-auto backdrop-blur-sm bg-white/60 rounded-xl p-12 shadow-xl border border-white/40">
                    {/* 404 Text */}
                    <div className="relative mb-8">
                        {/* Background 404 */}
                        <h1 className="text-9xl font-bold text-primary/5">404</h1>
                        {/* Foreground 404 */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <h1 className="text-9xl font-bold text-[#212529]">
                                404
                            </h1>
                        </div>
                    </div>

                    <h2 className="text-3xl font-bold mb-4 text-[#212529]">
                        {t('notFound.title')}
                    </h2>

                    <p className="text-xl text-[#212529]/70 mb-12 leading-relaxed font-light">
                        {t('notFound.message')}
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-wrap justify-center gap-8 mt-10">
                        <Link
                            to="/"
                            className="inline-flex items-center group bg-white/50 backdrop-blur-sm px-6 py-3 rounded-lg shadow-md border border-white/40 transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                        >
                            <FaHome className="mr-3 text-primary" />
                            <span className="text-[#212529] font-medium">{t('notFound.backToHome')}</span>
                            <FaArrowRight className="ml-2 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 text-primary" />
                        </Link>
                        <Link
                            to="/explore-motor"
                            className="inline-flex items-center group bg-white/50 backdrop-blur-sm px-6 py-3 rounded-lg shadow-md border border-white/40 transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                        >
                            <FaCogs className="mr-3 text-primary" />
                            <span className="text-[#212529] font-medium">Explore Our Motor</span>
                            <FaArrowRight className="ml-2 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 text-primary" />
                        </Link>
                        <Link
                            to="/contact"
                            className="inline-flex items-center group bg-white/50 backdrop-blur-sm px-6 py-3 rounded-lg shadow-md border border-white/40 transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                        >
                            <FaEnvelope className="mr-3 text-primary" />
                            <span className="text-[#212529] font-medium">{t('notFound.contactUs')}</span>
                            <FaArrowRight className="ml-2 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 text-primary" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;